module.exports = __webpack_public_path__ + "static/media/heavy_pound32.e80ead32.jpg";